/**
 * Colocación de paneles flotantes (selectores, calendarios, menús).
 *
 * Los desplegables se dibujan en un portal con `position: fixed`, así que hay
 * que decidir dónde ponerlos: debajo del campo si hay sitio y, si no, encima
 * (era el caso del calendario de «Fecha y hora» dentro de un diálogo, que se
 * salía por el borde inferior de la ventana).
 */

const MARGEN = 8;

export interface PosicionFlotante {
  top: number;
  left: number;
  /** `true` cuando se coloca por encima del campo. */
  encima: boolean;
}

/**
 * Calcula la posición del panel para un anclaje.
 *
 * @param ancla Caja del campo que abre el panel.
 * @param alto Alto aproximado del panel.
 * @param ancho Ancho del panel (para no salirse por la derecha).
 */
export function posicionarFlotante(ancla: DOMRect, alto: number, ancho: number): PosicionFlotante {
  const abajo = ancla.bottom + 4;
  const arriba = ancla.top - 4 - alto;
  const cabeAbajo = abajo + alto <= window.innerHeight - MARGEN;
  const cabeArriba = arriba >= MARGEN;
  const encima = !cabeAbajo && cabeArriba;

  const top = encima
    ? arriba
    : Math.max(MARGEN, Math.min(abajo, window.innerHeight - MARGEN - alto));

  const left = Math.max(MARGEN, Math.min(ancla.left, window.innerWidth - ancho - MARGEN));

  return { top, left, encima };
}
